export default {
    MuiInputBase: {
        input: {
            padding: '6px 2px 7px',
        },
    },
    MuiFormHelperText: {
        root: {
            '&$error': {
                color: '#f44336 !important',
            },
        },
    },
    MuiTableCell: {
        root: {
            padding: '8px 16px 8px 8px'
        },
        sizeSmall: {
            padding: '13px 16px 8px 13px'
        }
    },
    MuiIconButton: {
        sizeSmall: {
            padding: 0
        }
    },
    MuiSelect: {
        root: {
            fontSize: '0.875rem',
            fontFamily: 'inherit',
            fontWeight: 'inherit',
        }
    },
    MuiMenuItem: {
        root: {
            fontSize: '0.875rem',
            fontFamily: 'inherit',
            fontWeight: 'inherit'
        }
    }
};
